import * as React from 'react';
import { fetchJson } from '../helper/ajax';
import { Select, SelectProps } from '../Select/Select';

interface IInsuranceCompanySelectProps extends SelectProps {
  fetchCompaniesUrl?: string;
  fetchCompaniesOptions?: RequestInit;
}

interface IInsuranceCompany {
  id: string;
  name: string;
  code: string;
}

interface IState {
  companies: IInsuranceCompany[];
}

const sanitizeCompanyList = (oriList: IInsuranceCompany[]) => {
  const companies = [...oriList];
  // The first six entries from the service are the most popular insurance companies.
  const popularCompanies = companies.slice(0, 6);

  // 9244020 is the id of "Ej Oplyst"(meaning N/A in danish) insurance company,
  // and according to Julie, it should not be displayed in the drop-down list
  const remainingCompanies = companies
    .filter((company) => company.id !== '9244020') //
    .sort((com1, com2) => com1.name.localeCompare(com2.name));

  return popularCompanies.concat(remainingCompanies);
};

class InsuranceCompanySelectComponent extends React.Component<
  IInsuranceCompanySelectProps & { innerRef: React.Ref<HTMLSelectElement> },
  IState
> {
  static defaultProps: Partial<IInsuranceCompanySelectProps> = {
    fetchCompaniesOptions: {
      headers: {
        'Content-Type': 'application/json',
        'X-Top-Brand': 'TD',
        'X-Top-Host': 'tilbudsflowprod.topdanmark.local',
        'X-Top-Port': '80',
      },
      method: 'GET',
    },
    fetchCompaniesUrl: 'https://api.prod-04.topdanmark.dk/proxy/openapi/api/insurance-companies',
  };

  state: IState = {
    companies: [],
  };

  componentDidMount() {
    this.getCompanies();
  }

  getCompanies = () => {
    fetchJson(this.props.fetchCompaniesUrl as string, this.props.fetchCompaniesOptions)
      .then((companies: IInsuranceCompany[]) => this.setState({ companies: sanitizeCompanyList(companies) }))
      .catch(console.error);
  };

  render() {
    const { innerRef, fetchCompaniesOptions, fetchCompaniesUrl, ...selectProps } = this.props;
    return (
      <Select {...selectProps} ref={innerRef}>
        <option value="" aria-selected={!selectProps.value} />
        {this.state.companies.map((company, index) => (
          <option value={company.id} aria-selected={company.id === selectProps.value} key={company.id + index}>
            {company.name}
          </option>
        ))}
      </Select>
    );
  }
}

/**
 * @deprecated use `<flos-select-menu company-list="true"></flos-select-menu>` web component instead
 */
export const InsuranceCompanySelect = React.forwardRef<HTMLSelectElement, IInsuranceCompanySelectProps>(
  ({ ref: _, ...props }, ref) => <InsuranceCompanySelectComponent {...props} innerRef={ref} />
);

export default InsuranceCompanySelect;
